

import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { TFieldValidationResult } from "./CtaFieldValidations.types";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";
import { isFieldInvalid } from "./CtaFieldValidations.utils";


export const incomeFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    
    const validationResult: TFieldValidationResult = {}
    
    if (
        hasDefaultComponent('cob-corp-acquisition/components/creditonebank/personal-information-form')
        || hasDefaultComponent('cob-corp-acquisition/components/creditonebank/phone-number-and-income')
    ) {
        const {
            monthlyIncome
        } = validatingState.getPersonalInformation();

        if (isFieldInvalid(monthlyIncome)) {
            validationResult['MonthlyIncome'] = 'RequiredField';
        }
    }

    return validationResult;
}